import { Component, Input } from '@angular/core';
import { IPageTitleData } from '../../../core/interfaces/IPageTitle';

@Component({
  selector: 'app-page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
})
export class PageTitleComponent {
  @Input() pageTitle!: IPageTitleData;

  constructor() {}
}
